var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenlocationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C10.1651 14.5 12.103 14.8298 13.4814 15.3467C14.1725 15.6058 14.6973 15.9022 15.04 16.2061C15.3833 16.5104 15.5 16.7801 15.5 17C15.5 17.2199 15.3833 17.4896 15.04 17.7939C14.6973 18.0978 14.1725 18.3942 13.4814 18.6533C12.103 19.1702 10.1651 19.5 8 19.5C5.83494 19.5 3.89698 19.1702 2.51855 18.6533C1.82754 18.3942 1.30271 18.0978 0.959961 17.7939C0.616671 17.4896 0.5 17.2199 0.5 17C0.5 16.7801 0.616671 16.5104 0.959961 16.2061C1.30271 15.9022 1.82754 15.6058 2.51855 15.3467C3.89698 14.8298 5.83494 14.5 8 14.5Z",
    fill: "white",
    stroke: "#F20000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 5.0625C7.09335 5.0625 6.35851 5.81794 6.35851 6.75C6.35851 7.68206 7.09335 8.4375 7.99999 8.4375C8.90664 8.4375 9.64147 7.68206 9.64147 6.75C9.64147 5.81794 8.90664 5.0625 7.99999 5.0625ZM7.99999 9.5625C6.48929 9.5625 5.2642 8.30362 5.2642 6.75C5.2642 5.19637 6.48929 3.9375 7.99999 3.9375C9.5107 3.9375 10.7358 5.19637 10.7358 6.75C10.7358 8.30362 9.5107 9.5625 7.99999 9.5625ZM7.99999 0C4.37397 0 1.43408 3.02231 1.43408 6.75C1.43408 9.57262 6.90841 18.0062 7.99999 18C9.07461 18.0062 14.5659 9.53437 14.5659 6.75C14.5659 3.02231 11.626 0 7.99999 0Z",
    fill: "#2C963D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.86251,
    cy: 6.42843,
    r: 3.85714,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenlocationicon);
export default __webpack_public_path__ + "static/media/greenlocationicon.bcaf4379476d41094632e63d8aaac45b.svg";
export { ForwardRef as ReactComponent };